export const filterRarityList = [
  {
    label: "全部星级",
    value: "all",
  },
  {
    label: "1~3星干员",
    value: "3",
  },
  {
    label: "4星干员",
    value: "4",
  },
  {
    label: "5星干员",
    value: "5",
  },
  {
    label: "6星干员",
    value: "6",
  },
];

export const sortList = [
  {
    label: "角色等级",
    value: "level",
  },
  {
    label: "获取时间",
    value: "gainTime",
  },
  {
    label: "干员潜能",
    value: "potentialRank",
  },
  {
    label: "干员好感",
    value: "favorPercent",
  },
];

export const filterProfessionList = [
  {
    label: "全部职业",
    value: "all",
  },
  {
    label: "先锋",
    value: "PIONEER",
  },
  {
    label: "近卫",
    value: "WARRIOR",
  },
  {
    label: "重装",
    value: "TANK",
  },
  {
    label: "狙击",
    value: "SNIPER",
  },
  {
    label: "术师",
    value: "CASTER",
  },
  {
    label: "医疗",
    value: "MEDIC",
  },
  {
    label: "辅助",
    value: "SUPPORT",
  },
  {
    label: "特种",
    value: "SPECIAL",
  },
];
